<script setup>
    import { router } from '@inertiajs/vue3';
    import { onMounted, reactive } from 'vue';
    import JetButton from '@/Jetstream/Button.vue';
    import '@vueup/vue-quill/dist/vue-quill.snow.css';
    import '@vuepic/vue-datepicker/dist/main.css';
    import ToolkitAuditorTeamQuestion from '@/Pages/Toolkit/Partials/ToolkitAuditorTeamQuestion.vue';

    // includes we need to front end locale magic
    import { useI18n } from 'vue-i18n';

    // Get locale as set in cookie
    const { locale, fallbackLocale} = useI18n({ useScope: 'global' });

    // Check if in auditor mode
    let auditor = false;
    let auditorTeamQuestions = [];
    let auditorTeamAnswers = [];
    if (router.page.props.auditor) {
        auditor = router.page.props.auditor;
        auditorTeamQuestions = router.page.props.auditorTeamQuestions;
        auditorTeamAnswers = router.page.props.auditorTeamAnswers;
    }


    const props = defineProps({
        toolkit: Object,
        auditor: Boolean,
        auditorTeamQuestions: Array,
        adminAudit: Boolean
    });
    const toolkitID = props.toolkit.toolkit_id;

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    const formData = reactive([]);

    //Loop through each custom question and build the formData reactive array.
    let question_id = 0;
    auditorTeamQuestions.forEach(function (auditorTeamQuestion) {
        formData.push({
            "index_id": question_id,
            "input_type": auditorTeamQuestion.type,
            "question_id": auditorTeamQuestion.id,
            "toolkit_id": toolkitID,
            //"team_id": 1,
            //"auditor_code_id": 186,
            "answer": '',
            "required": auditorTeamQuestion.required
        });
        auditorTeamQuestion["index_id"] = question_id;
        question_id++;
    });

    let formDataItemQuestionID;
    let unansweredRequiredQuestions = false;

    // Assign answers
    formData.forEach(function (formDataItem) {
        formDataItemQuestionID = formDataItem.question_id;

        auditorTeamAnswers.forEach(function (auditorTeamAnswer) {
            if ( auditorTeamAnswer.auditor_team_question_id == formDataItemQuestionID ) {

                if(formDataItem.input_type == 'checkbox') {
                    auditorTeamAnswer.answer = (auditorTeamAnswer.answer == '1' ? 'true' : auditorTeamAnswer.answer);
                }
                formDataItem.answer = auditorTeamAnswer.answer;
            }
        });
    });

    const displaySuccessMessage = () => {
    const saveSuccessAlert = document.getElementById('alert-save-success');
    saveSuccessAlert.classList.remove('alert-hidden');
    }
    const hideSuccessMessage = () => {
        const saveSuccessAlert = document.getElementById('alert-save-success');
        saveSuccessAlert.classList.add('alert-hidden');
    }

    const displayErrorMessage = () => {
        const saveErrorAlert = document.getElementById('alert-save-error');
        saveErrorAlert.classList.remove('alert-hidden');
    }

    const hideErrorMessage = () => {
        const saveErrorAlert = document.getElementById('alert-save-error');
        saveErrorAlert.classList.add('alert-hidden');
    }

    // Check for unanswered questions
    formData.forEach(function (formDataItem) {
        if ( formDataItem.answer == '' & formDataItem.required == 1) {
        unansweredRequiredQuestions = true;
        }
    });

    // This is the function that posts updated questions data to the database
    const UpdateAuditorTeamQuestions = ($event) => {

        formData.forEach(function (formDataItem) {
            delete formDataItem.index_id;
        });

        router.post(route(urlNamePrefix + 'auditor.auditor-team-questions.updateAuditorTeamQuestions', { 'subdomain': 'auditor'}),
        {
            formData
        },
        {
            preserveState: true,
            preserveScroll: true,
            onSuccess: function() {
                console.log('Success!');
                displaySuccessMessage();
                hideErrorMessage();

            },
            onError: (errors) => {
                console.log('Fail!');
                displayErrorMessage();
                hideSuccessMessage();
            },

        });

    }


    // Reactive variable to store accordion toggle button text
    const auditorQuestionsToggleText = reactive({
        status: 'auditor.toolkit.auditor_show_team_questions'
    });

    // Accordion function for auditor team questions
    onMounted(() => {
        const trigger = '#toolkit-auditor-questions-trigger';
        const expandable = '#toolkit-auditor-questions-content';
        $(trigger).on('click', function (e) {
            e.preventDefault();
            $(expandable).slideToggle();
            $('#toolkit-auditor-questions-trigger').toggleClass('auditor-questions-open');
            var button = $('#toolkit-auditor-questions-trigger');
            if ( button.hasClass('auditor-questions-open') ) {
                auditorQuestionsToggleText.status = 'auditor.toolkit.auditor_hide_team_questions';
            } else {
                auditorQuestionsToggleText.status = 'auditor.toolkit.auditor_show_team_questions';
            }
        });

        if ( unansweredRequiredQuestions == true ) {
            $('#alert-save-info').removeClass('alert-hidden');
        }

        $('#alert-save-info .alert-close').on('click', function (e) {
        e.preventDefault();
            $('#alert-save-info').addClass('alert-hidden');
        });
        $('#alert-save-success .alert-close').on('click', function (e) {
        e.preventDefault();
            $('#alert-save-success').addClass('alert-hidden');
        });
        $('#alert-save-error .alert-close').on('click', function (e) {
        e.preventDefault();
            $('#alert-save-error').addClass('alert-hidden');
        });
    });

</script>

<template>

    <div v-if="auditor" id="toolkit-auditor-questions" class="flex-wrap justify-between w-full p-5 pb-10 mb-5 bg-white xl:flex rounded-2xl">

        <div id="toolkit-auditor-questions-header" class="items-center justify-between w-full lg:flex">
            <div class="w-2/3 font-bold">
                {{ $t( 'auditor.toolkit.auditor_team_questions_heading' ) }}
            </div>
            <div class="w-1/3">
                <div id="toolkit-auditor-questions-trigger" class="font-bold text-center text-white rounded-md btn btn-toolkit-primary btn-action-control upper-case" aria-role="button" aria-label="Expand auditor questions">
                    {{ $t( auditorQuestionsToggleText.status ) }}
                </div>
            </div>
        </div>

        <div id="toolkit-auditor-questions-content" class="w-full form-control">
            <div class="pt-5 pb-5 toolkit-auditor-questions-content-inner-wrapper">

                <div id="alert-save-info" class="p-5 mb-5 bg-blue-100 rounded alert alert-success">
                    <div class="flex justify-between">
                        <div class="flex space-x-3">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-4 h-4 text-blue-500 fill-current">
                            <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z" /></svg>
                            <div class="flex-1 text-sm font-medium leading-tight text-blue-700">{{ $t('auditor.auditor_questions.auditor_questions_save_reminder') }}</div>
                        </div>
                        <button class="alert-close">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-3 h-3 text-blue-600 fill-current">
                            <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
                        </button>
                    </div>
                </div>

                <div id="alert-save-success" class="p-5 mb-5 bg-green-100 rounded alert alert-success alert-hidden">
                    <div class="flex justify-between">
                        <div class="flex space-x-3">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-4 h-4 text-green-500 fill-current">
                            <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 16.518l-4.5-4.319 1.396-1.435 3.078 2.937 6.105-6.218 1.421 1.409-7.5 7.626z" /></svg>
                            <div class="flex-1 text-sm font-medium leading-tight text-green-700">{{ $t('teams.questions.saved') }}</div>
                        </div>
                        <button class="alert-close">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-3 h-3 text-green-600 fill-current">
                            <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
                        </button>
                    </div>
                </div>

                <div id="alert-save-error" class="p-5 mb-5 bg-red-100 rounded alert alert-success alert-hidden">
                    <div class="flex justify-between">
                    <div class="flex space-x-3">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-4 h-4 text-red-500 fill-current">
                            <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.597 17.954l-4.591-4.55-4.555 4.596-1.405-1.405 4.547-4.592-4.593-4.552 1.405-1.405 4.588 4.543 4.545-4.589 1.416 1.403-4.546 4.587 4.592 4.548-1.403 1.416z" /></svg>
                            <div class="flex-1 text-sm font-medium leading-tight text-red-700">{{ $t('auditor.auditor_questions.auditor_questions_error_message') }}</div>
                    </div>
                    <button class="alert-close">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="flex-none w-3 h-3 text-red-600 fill-current">
                        <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" /></svg>
                    </button>
                    </div>
                </div>

                <form @submit.prevent="UpdateAuditorTeamQuestions">

                    <div v-if="auditorTeamQuestions.length !== 0">
                            <ToolkitAuditorTeamQuestion
                                v-for="auditorTeamQuestion in auditorTeamQuestions"
                                :auditorTeamQuestion="auditorTeamQuestion"
                                :key="auditorTeamQuestion.index_id"
                                :formData="formData"
                                :datePicker="datePicker"
                                :adminAudit="adminAudit"
                            />

                            <JetButton
                                :disabled="adminAudit"
                                type="submit"
                                class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-white uppercase transition bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25"
                                >
                                {{ $t('teams.questions.save') }}
                            </JetButton>
                    </div>

                </form>

            </div>
        </div>

    </div>



</template>

